module.exports = __webpack_public_path__ + "assets/img/customers2.db7b460b.png";